import React, { useState, useEffect } from "react";

export const PreloaderSvg: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 30000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!loading) return null;

  return (
    <div style={styles.container}>
      <div style={styles.spinnerWrapper}>
        <div style={styles.rotatingRingWrapper}>
          <img src="/Vector.svg" alt="Rotating Ring" style={styles.rotatingRing} />
          <img src="/logo.svg" alt="Logo" style={styles.logo} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed" as "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  },
  spinnerWrapper: {
    position: "relative" as "relative",
    width: "200px",
    height: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rotatingRingWrapper: {
    position: "relative" as "relative",
    width: "200px",
    height: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rotatingRing: {
    width: "200px",
    height: "200px",
    position: "absolute" as "absolute",
    animation: "spin 2s linear infinite",
  },
  logo: {
    width: "120px",
    height: "120px",
    position: "absolute" as "absolute",
    zIndex: 1,
  },
};

const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);
